import moment from 'moment';
import { message } from "antd";
import { getLangList } from "@/lib/i18n";

export const dateFormat = 'YYYY-MM-DD';

export const dateFormatSlash = 'YYYY/MM/DD';

export const dateTimeFormat = 'YYYY-MM-DD HH:mm:ss';

export const dateTimeFormat2 = 'YYYY/MM/DD HH:mm:ss';

export const dateTimeFormat3 = 'MM-DD';

export const dateTimeFormat4 = 'YYYY-MM-DD HH:mm';

export const dateTimeFormat5 = 'YYYY-MM';

export const dateTimeFormat6 = 'YYYY';

export const dateTimeFormat7 = 'DD';

export const dateTimeFormat8 = 'YYYY/MM/DD HH:mm';

export const dateTimeFormat9 = 'DD/MM/YYYY';

export const dateFormatTwo = 'YY-MM-DD HH:mm:ss';

export const timeHrMin = 'HH:mm';

export const timeHrMinSec = 'HH:mm:ss';

export const announcementTime = 'MM-DD HH:mm';

// 全域變數 不要拿來做加減天
export const currentTime = moment();
export const startTimeToday = moment().startOf('day');
export const endTimeToday = moment().endOf('day');
const startTimeYesterday = moment().subtract(1, "days").startOf('day');
const endTimeYesterday = moment().subtract(0, "days").endOf('day');
const startLast7Days = moment().subtract(7, "days").startOf('day');
const endLast7Days = moment().subtract(0, "days").endOf('day');
const startLast30Days = moment().subtract(30, "days").startOf('day');
const endLast30Days = moment().subtract(1, "days").endOf('day');
const startThisWeek = moment().startOf("week");
const endThisWeek = moment().endOf("week");
const startLastWeek = moment().subtract(1, "week").startOf("week");
const endLastWeek = moment().subtract(1, "week").endOf("week");
export const startThisMonth = moment().startOf("month");
export const endThisMonth = moment().endOf("month");
const startLastMonth = moment().month(moment().month() - 1).startOf("month");
const endLastMonth = moment().month(moment().month() - 1).endOf("month");
export const startThisYear = moment().startOf("year");
export const endThisYear = moment().endOf("year");
const lastThirtyYear = moment().year() - 30;
const nextTenYear = moment().year() + 10;
export const yearArray = Array.from({ length: nextTenYear - lastThirtyYear + 1 }, (_, index) => `${lastThirtyYear + index}`);

// 根據call function的時間點，來取得特定的時間 
export const getCurrentTime = () => moment();
export const getStartTimeToday = () => moment().startOf('day');
export const getEndTimeToday = () => moment().endOf('day');
export const getStartTimeBeforeXDays = (value: number) => moment().subtract(value, "days").startOf('day');
export const getEndTimeAfterXDays = (value: number) => moment().add(value, "days").endOf('day');

export const getCurrentAcademicYear = () => {
  const year = moment().year();
  const month = moment().month(); // 0-11，0是1月，11是12月

  return month < 6 ? year - 1 : year;
};

export const datePickerStyle = { width: "100%", height: "100%" };

export const getMoment = (date: any) => {
  return moment(date);
};

export const convertToTimestamp = (date: any) => {
  return moment(date).valueOf();
};

export const convertToTimestamp10 = (date: any) => {
  return `${moment(date).valueOf()}`.substr(0, 10) + '000';
};

export const convertTimestampToFormat = (timestamp: number, format: string) => {
  return moment(timestamp).format(format);
};

export const rangeMessage = (isInRange: boolean, limitDay: number) => {
  const t: any = getLangList('error', 'unit');
  return !isInRange ? message.error(`${t.date_range_error} ${limitDay} ${t.days}`) : '';
};

export const isDateInRange = (timeArray: any = [], limitDay: number) => {
  const isInRange = moment(timeArray[1]).diff(moment(timeArray[0]), 'days') < limitDay;
  rangeMessage(isInRange, limitDay);
  return isInRange;
};

export const setRangePickerTimeValue = (timeRrom: any, timeTo: any) => {
  return [
    moment(`${startTimeToday.format(dateFormat)} ${timeRrom}`),
    moment(`${startTimeToday.format(dateFormat)} ${timeTo}`),
  ];
};

export const rangePickerOptions = (options: string[] = ['ALL']) => {
  const rangeT: any = getLangList('ANTD');
  const allOptions: any = ['TODAY', 'YESTERDAY', 'LAST_7_DAYS', 'LAST_30_DAYS', 'THIS_WEEK', 'LAST_WEEK', 'THIS_MONTH', 'LAST_MONTH'];
  const rangeMoment: any = {
    TODAY: [endTimeToday, startTimeToday],
    YESTERDAY: [startTimeYesterday, endTimeYesterday],
    LAST_7_DAYS: [startLast7Days, endLast7Days],
    LAST_30_DAYS: [startLast30Days, endLast30Days],
    THIS_WEEK: [startThisWeek, endThisWeek],
    LAST_WEEK: [startLastWeek, endLastWeek],
    THIS_MONTH: [startThisMonth, endThisMonth],
    LAST_MONTH: [startLastMonth, endLastMonth],
  };
  const mappingArray = (stringArray: string[]) => {
    return new Map(stringArray.map((item: any) => [rangeT.DATEPICKER[item], rangeMoment[item]]));
  };
  const mapArray: any = options.includes('ALL')
    ? mappingArray(allOptions)
    : mappingArray(options);

  return Object.fromEntries(mapArray);
};

export const translateDay = (day: number) => {
  switch (day) {
    case -1:
      return '日';
    case 0:
      return '一';
    case 1:
      return '二';
    case 2:
      return '三';
    case 3:
      return '四';
    case 4:
      return '五';
    case 5:
      return '六';
    case 6:
      return '日';
  }
}

// Calendar
export const getDateCellDataArray = (date: any, dataArray: any) => {
  const todayArray = dataArray.filter((item: any) => {
    const { startTime, endTime } = item ?? {};
    const start = moment(startTime).format(dateFormat);
    const end = moment(endTime).format(dateFormat);
    const isTodayInRange = moment(date).isBetween(start, end);
    const isSameDay = moment(date.format(dateFormat)).isSame(start) || moment(date.format(dateFormat)).isSame(end);
    return isTodayInRange || isSameDay;
  });

  return todayArray;
}

// Calendar
export const disabledMonth = (beforeMonth: number, afterMonth: number) => (current: any) => {
  const isBeforThisMonth = current < moment().month(moment().month() - beforeMonth).startOf("month");
  const isBetweenOneYear = current > moment().month(moment().month() + afterMonth).startOf("month");

  return current && (isBeforThisMonth || isBetweenOneYear);
}

export const getDayVacationDateParams = ({ specialDateArray, startDate = getStartTimeToday() }: any) => {
  let isInDate = 0;
  let vacationDayOfWeekIndex = -1;
  const today = moment(startDate).format(dateTimeFormat3);

  specialDateArray.forEach((item: any) => {
    const { startTime, endTime, isVacation } = item;
    const start = moment(startTime);
    const end = moment(endTime);
    const isSameDay = today === start.format(dateTimeFormat3) || today === end.format(dateTimeFormat3);

    if (isVacation && isSameDay) {
      isInDate++;
      vacationDayOfWeekIndex = getMoment(start).weekday() - 1;
    }
  });

  return {
    isDayVacationDay: isInDate > 0,
    vacationDayOfWeekIndex,
  };
}

export const getDayMakeUpDateParams = ({ specialDateArray, startDate = getStartTimeToday() }: any) => {
  let isInDate = 0;
  let makeUpDayOfWeekIndex = -1;
  const today = moment(startDate).format(dateTimeFormat3);

  specialDateArray.forEach((item: any) => {
    const { startTime, endTime, isMakeUpDay, makeUpDate } = item;
    const start = moment(startTime);
    const end = moment(endTime);
    const isSameDay = today === start.format(dateTimeFormat3) || today === end.format(dateTimeFormat3);

    if (isMakeUpDay && isSameDay) {
      isInDate++;
      makeUpDayOfWeekIndex = getMoment(makeUpDate).weekday() - 1;
    }
  });

  return {
    isDayMakeUpDay: isInDate > 0,
    makeUpDayOfWeekIndex,
  };
}

export const dayOfWeekArray = ['一', '二', '三', '四', '五', '六', '日'];

export const todayOfWeek = dayOfWeekArray[startTimeToday.weekday() - 1];

export const exampleSpecialDateArray: any = [
  {
    endTime: 1694876400000,
    isMakeUpDay: 1,
    isVacation: 0,
    makeUpDate: 1694016000000, // 9/7 四
    startTime: 1694793600000, // 9/16 六
  },
  {
    endTime: 1694790000000,
    isMakeUpDay: 0,
    isVacation: 1,
    makeUpDate: null,
    startTime: 1694707200000, // 9/15 五
  },
  {
    endTime: 1695052799000,
    isMakeUpDay: 0,
    isVacation: 1,
    makeUpDate: null,
    startTime: 1694966400000, // 9/18 一
  },
  {
    endTime: 1695916799000,
    isMakeUpDay: 1,
    isVacation: 0,
    makeUpDate: 1696003200000, // 9/30 六
    startTime: 1695830400000, // 9/28 四
  },
  {
    endTime: 1695743999000,
    isMakeUpDay: 0,
    isVacation: 1,
    makeUpDate: null,
    startTime: 1695657600000, // 9/26 二
  },
];